import { Modal } from 'antd'
import { AppStore } from 'src/pc/store/AppStore'
import { useState } from 'react'
import DDModal from 'src/pc/components/DDModal'

const useSwitchPayTips = () => {
  const [flag, setFlag] = useState<boolean>(false)

  const isNeedTips = (payWay: TPayWay, needTips: boolean) => {
    if (payWay === 'wechat' && needTips && !flag && AppStore.switchPayTips && AppStore.switchPayTips['新版管家']) {
      DDModal.warn({
        zIndex: 1111,
        title: '提示',
        content: AppStore.switchPayTips['新版管家'],
      })
      setFlag(true)
      return true
    }
    return false
  }

  const reloadFlag = () => {
    setFlag(false)
  }

  return {
    isNeedTips,
    reloadFlag,
  }
}

export default useSwitchPayTips
